export default __webpack_public_path__ + "static/media/iBaby.9c541594.svg";